import { stateGo } from 'redux-ui-router';
import { selectMemberLevel } from 'logic/member';
import {
  fetchMealPlan,
  fetchMealPlanActive,
  selectMealPlanIsClone,
  selectMealPlan,
  updateMealPlan,
} from 'logic/mealPlan';

export const NutritionMealPlan = {
  template: `
    <div class="nutrition-meal-plan bg-white">
      <header class="container text-center pt-4 pb-3">
        <div class="row">
          <div class="col-md-8 mx-auto">
            <header class="mb-3"
              ng-hide="$ctrl.isEditing">
              <h2 class="m-0">
                <spinner is-loading="$ctrl.isLoading">
                  {{ $ctrl.mealPlan.title || 'Loading...' }}
                </spinner>
              </h2>
              <span>
                <button-link
                  ng-click="$ctrl.isEditing = true; title = null;"
                  ng-show="$ctrl.mealPlan.associatedId">
                  <small>Edit Name</small>
                </button-link>
              </span>
            </header>
            <form class="col-12 col-md-6 p-0 mx-auto d-flex flex-row align-items-center mb-3"
              name="form"
              ng-submit="$ctrl.updateMealPlan($ctrl.mealPlan.id, { title: title }); $ctrl.isEditing = false;"
              ng-show="$ctrl.isEditing"
              no-validate>
              <label class="sr-only" for="mealPlanTitle">Username</label>
              <div class="input-group mr-3">
                <input class="form-control"
                  id="mealPlanTitle"
                  type="text"
                  placeholder="{{ $ctrl.mealPlan.title }}"
                  name="title"
                  ng-model="title"
                  ng-minLength="6"
                  ng-required>
                <div class="input-group-append">
                  <div class="input-group-text">
                    <button class="btn btn-link p-0"
                      ng-disabled="form.$pristine || form.$invalid"
                      type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </div>
              <button-link ng-click="$ctrl.isEditing = false">
                Cancel
              </button-link>
            </form>
            <p ng-if="$ctrl.mealPlan.description">
              {{ $ctrl.mealPlan.description }}
            </p>
            <meal-plan-nav
              name="$ctrl.name"
              meal-plan-name="nutrition.mealPlans.detail"
              shopping-list-name="nutrition.mealPlans.detail.shoppingList"
              is-disabled="!$ctrl.mealPlan || $ctrl.mealPlan.recipeCount < 1"
              on-click="$ctrl.stateGo(name)">
            </meal-plan-nav>
          </div>
        </div>
      </header>
      <ui-view>
        <meal-plan></meal-plan>
      </ui-view>
    </div>`,

  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        const connect = $ngRedux.connect(this.mapState, this.mapDispatch());
        this.disconnect = connect(this);

        this.fetchMealPlan(this.mealPlanId, this.level);

        if (!this.active) {
          this.fetchMealPlanActive();
        }

        this.type = this.isClone ? 'mine' : 'byVoome';
      },

      $onDestroy() {
        if (location.pathname === '/nutrition/meal-plans') {
          this.stateGo('nutrition.mealPlans', { type: this.type });
        }

        this.disconnect();
      },

      mapState({ mealPlan, member, router }) {
        const { mealPlanId } = router.currentParams;
        const { name } = router.currentState;
        const { active, isLoading } = mealPlan;

        return {
          active,
          isLoading,
          mealPlanId,
          name,
          isClone: selectMealPlanIsClone(mealPlan, mealPlanId),
          level: selectMemberLevel(member),
          mealPlan: selectMealPlan(mealPlan, mealPlanId),
        };
      },

      mapDispatch() {
        return {
          fetchMealPlan,
          fetchMealPlanActive,
          stateGo,
          updateMealPlan,
        };
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Nutrition/MealPlan.js